<template lang='pug' src='./custom-about-team.pug'></template>

<script>
import TeamTabcontent from './team-tabcontent/team-tabcontent'

export default {
  props: ['content'],
  data () {
    return {
      showTeamTab: false
    }
  },
  methods: {
    showTeamTabFunc (num) {
      this.showTeamTab = true
      var tab = document.getElementsByClassName('about-team-tab__active')
      var selectTab = document.getElementById('team-tab-' + num)
      var tabcontent = document.getElementsByClassName('team-tabcontent__active')
      var selectTabContent = document.getElementById('team-tabcontent-' + num)
      if (tabcontent[0]) {
        tabcontent[0].classList.remove('team-tabcontent__active')
        tab[0].classList.remove('about-team-tab__active')
      }
      selectTab.classList.toggle('about-team-tab__active')
      selectTabContent.classList.toggle('team-tabcontent__active')
    }
  },
  mounted () {
    this.showTeamTabFunc(0)
  },
  components: {
    TeamTabcontent
  }
}
</script>



// WEBPACK FOOTER //
// custom-about-team.vue?40ac5788